<!--
  --
  -- ユーザ制約 コンポーネント
  --
  -->
<template>
  <v-sheet class="px-4 py-2">
    <div class="subtitle-2 text--secondary mb-2">次の制約を受ける場合があります</div>
    <div class="d-flex flex-wrap mx-n1">
      <c-limited-label class="ma-1" v-if="limited.beginner">初心者マーク</c-limited-label>
      <c-limited-label class="ma-1" v-if="limited.minor">未成年</c-limited-label>
      <c-limited-label class="ma-1" v-if="limited.at">AT限定</c-limited-label>
      <c-limited-label class="ma-1" v-if="limited.firstTime">初回利用</c-limited-label>
    </div>
  </v-sheet>
</template>

<script>
import CLimitedLabel from './CLimitedLabel'

export default {
  name: 'CLimitedSheet',
  components: {
    CLimitedLabel
  },
  props: {
    limited: {
      type: Object,
      required: true
    }
  }
}
</script>
